var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    height:
      _vm.Config.BLOCK_SIZE * 5 +
      _vm.Config.GRID_BORDER * 2 -
      _vm.Config.BLOCK_BORDER +
      'px',
    width:
      _vm.Config.BLOCK_SIZE * 5 +
      _vm.Config.GRID_BORDER * 2 -
      _vm.Config.BLOCK_BORDER +
      'px',
    borderWidth: _vm.Config.GRID_BORDER + 'px',
  }),attrs:{"id":"grid"}},_vm._l((_vm.blocks),function(bl){return _c('Block',{key:bl.id,style:({
      top: bl.x * _vm.Config.BLOCK_SIZE - _vm.Config.BLOCK_BORDER + 'px',
      left: bl.y * _vm.Config.BLOCK_SIZE - _vm.Config.BLOCK_BORDER + 'px',
    }),attrs:{"light":_vm.light[bl.x][bl.y],"colorId":0,"ox":"X"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }